<template>
	<div class="tabContainer px-3">
		<div class="d-flex">
			<v-text-field
				v-model="search"
				class="py-0 mr-2"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			/>
			<v-btn @click.stop="addFilter" color="primary">
				<v-icon> mdi-plus</v-icon>
				Add Filter
			</v-btn>
		</div>
		<div class="tabInnerContainer">
			<v-data-table
				dense
				hide-default-footer
				disable-pagination
				fixed-header
				loading-text="Loading..."
				:items="reportFilters"
				:headers="headers"
				:search.sync="search"
			>
				<template v-slot:[`item.Schema`]="{ item }">
					{{ getReportFieldSchema(item) }}
				</template>

				<template v-slot:[`item.Field`]="{ item }">
					{{ getReportFieldName(item) }}
				</template>

				<template v-slot:[`item.Operator`]="{ item }">
					{{ getFilterOperator(item) }}
				</template>

				<template v-slot:[`item.actions`]="{ item }">
					<v-btn
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="editFilter(item)"
					>
						<v-icon color="primary" small>mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="deleteFilter(item)"
					>
						<v-icon color="error" small>mdi-delete</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</div>
		<v-container fluid class="mt-2">
			<v-row no-gutters>
				<v-spacer />
				<v-btn text outlined @click="onCancel">Cancel</v-btn>
			</v-row>
		</v-container>
		<report-filter-modal
			v-if="showDialog"
			:showDialog="showDialog"
			:reportFilter="selectedFilter"
			@close="hideModal"
		/>
	</div>
</template>
<script>
import ReportFilterModal from './ReportFilterModal.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { ReportDetailsActions } from '../../../../../store/actions';
import { mapGetters } from 'vuex';
import { reportTypes } from '../../../../../enums/reportTypes';
import { advancedFilterOperators } from '../../../../../enums/dropdownHelpers/advancedFilterOperators';

export default {
	name: 'ReportFilters',
	components: {
		ReportFilterModal,
	},
	computed: {
		...mapGetters({
			reportFilters: [ReportDetailsGetters.REPORT_FILTERS],
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
			reportFields: [ReportDetailsGetters.REPORT_FIELDS],
		}),
	},
	data() {
		return {
			showDialog: false,
			search: '',
			selectedFilter: null,
			headers: [
				{ text: 'Schema', value: 'Schema', sortable: false },
				{ text: 'Field', value: 'Field', sortable: false },
				{ text: 'Operator', value: 'Operator', sortable: false },
				{ text: 'Value', value: 'Value', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	methods: {
		onCancel() {
			this.$router.push({ name: 'ReportBuilder' });
		},
		deleteFilter(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this Report Filter?',
			}).then((success) => {
				if (!success) return;
				this.$store.dispatch(
					ReportDetailsActions.DELETE_REPORT_FILTER,
					item
				);
			});
		},
		editFilter(item) {
			this.selectedFilter = item;
			this.showDialog = true;
		},
		addFilter() {
			this.showDialog = true;
		},
		hideModal() {
			this.showDialog = false;
			this.selectedFilter = null;
		},
		getReportFieldName(filter) {
			if (!this.reportFields) return null;
			let field = this.reportFields.find(
				(x) => x.Id == filter.ReportFieldId
			);
			if (!field) return null;
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return field.Source;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			return gvf.Label;
		},
		getReportFieldSchema(filter) {
			if (!this.reportFields) return null;
			let field = this.reportFields.find(
				(x) => x.Id == filter.ReportFieldId
			);
			if (!field) return null;
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return this.report.CustomData;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			if (!this.schemas) return null;
			let schema = this.schemas.find((x) => x.Id == gvf.EntityId);
			if (!schema) return null;
			return schema.Name;
		},
		getFilterOperator(filter) {
			let operator = advancedFilterOperators.find(
				(x) => x.value == filter.Operator
			);
			if (!operator) return null;
			return operator.label;
		},
	},
};
</script>
<style lang="scss" scoped>
.tabContainer {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
	.tabInnerContainer {
		flex-grow: 1;
	}
}
</style>
